import { Button } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  DRAWER_HEADER_ACTIONS_ID,
  DRAWER_HEADER_ACTIONS_ID_MOBILE,
  ROUTES,
} from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import EndUsersTabs from '../components/EndUsersTabs';
import SubscriptionInfo from '../components/SubscriptionInfo';

const SubscriptionDetails = ({
  match: { params: { id, userNumber } = {} } = {},
  isDrawerView = false,
  // Props for drawer mode
  userId: drawerUserId,
  userNumber: drawerUserNumber,
}) => {
  const {
    state: { endUserDetails, isDesktop },
  } = useContext(AppContext);

  // Use drawer props if in drawer mode, otherwise use route params
  const currentId = isDrawerView ? drawerUserId : id;
  const currentUserNumber = isDrawerView ? drawerUserNumber : userNumber;

  const [isDeliveryModalOpen, setIsDeliveryModalOpen] = useState(false);
  const [isHoldingModalOpen, setIsHoldingModalOpen] = useState(false);
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
  const [isExpiryDateModalOpen, setIsExpiryDateModalOpen] = useState(false);
  const [isSubscriptionBtnDisable, setIsSubscriptionBtnDisable] = useState(
    true,
  );
  const [isExpiryDateBtnDisable, setIsExpiryDateBtnDisable] = useState(true);
  const [isDeliveryBtnDisable, setIsDeliveryBtnDisable] = useState(true);
  const [isUpdatePlanModalOpen, setIsUpdatePlanModalOpen] = useState(false);
  const [isUpdatePlanBtnDisable, setIsUpdatePlanBtnDisable] = useState(true);
  const [isPlanListEmpty, setIsPlanListEmpty] = useState(false);

  const ActionButtons = () => {
    const buttonType = isDrawerView ? 'primary' : undefined;
    const marginClass = isDrawerView ? 'mr-8' : 'mr-16';
    const lastButtonMargin = isDrawerView ? 'mr-8' : '';
    const buttonClass = isDrawerView ? '' : 'common-button';

    return (
      <div className="header-btn-wrapper">
        <Button
          className={`${buttonClass} ${marginClass}`}
          size="middle"
          onClick={() => setIsSubscriptionModalOpen(true)}
          disabled={isSubscriptionBtnDisable}
        >
          Activate Subscription
        </Button>
        <Button
          className={`${buttonClass} ${marginClass}`}
          size="middle"
          onClick={() => setIsExpiryDateModalOpen(true)}
          disabled={isExpiryDateBtnDisable}
        >
          Edit Expiry Date
        </Button>
        <Button
          className={`${buttonClass} ${marginClass}`}
          size="middle"
          onClick={() => setIsDeliveryModalOpen(true)}
          disabled={isDeliveryBtnDisable}
        >
          Edit Free Deliveries
        </Button>
        <Button
          className={`${buttonClass} ${lastButtonMargin}`}
          size="middle"
          onClick={() => setIsHoldingModalOpen(true)}
        >
          Edit Toy Holdings
        </Button>
        <Button
          className={buttonClass}
          size="middle"
          onClick={() => setIsUpdatePlanModalOpen(true)}
          disabled={isUpdatePlanBtnDisable}
        >
          Update Subscription
        </Button>
      </div>
    );
  };

  const subscriptionInfoComponent = (
    <SubscriptionInfo
      isDeliveryModalOpen={isDeliveryModalOpen}
      setIsDeliveryModalOpen={setIsDeliveryModalOpen}
      isHoldingModalOpen={isHoldingModalOpen}
      setIsHoldingModalOpen={setIsHoldingModalOpen}
      isSubscriptionModalOpen={isSubscriptionModalOpen}
      setIsSubscriptionModalOpen={setIsSubscriptionModalOpen}
      isExpiryDateModalOpen={isExpiryDateModalOpen}
      setIsExpiryDateModalOpen={setIsExpiryDateModalOpen}
      userId={currentId || endUserDetails?.id}
      isView={false}
      setIsSubscriptionBtnDisable={setIsSubscriptionBtnDisable}
      setIsExpiryDateBtnDisable={setIsExpiryDateBtnDisable}
      setIsDeliveryBtnDisable={setIsDeliveryBtnDisable}
      isUpdatePlanModalOpen={isUpdatePlanModalOpen}
      setIsUpdatePlanModalOpen={setIsUpdatePlanModalOpen}
      setIsUpdatePlanBtnDisable={setIsUpdatePlanBtnDisable}
      isPlanListEmpty={isPlanListEmpty}
      setIsPlanListEmpty={setIsPlanListEmpty}
    />
  );

  if (isDrawerView) {
    return (
      <>
        {isDesktop ? (
          <Portal portalId={DRAWER_HEADER_ACTIONS_ID}>
            <div className="drawer-header-actions">
              <ActionButtons />
            </div>
          </Portal>
        ) : (
          <Portal portalId={DRAWER_HEADER_ACTIONS_ID_MOBILE}>
            <div className="drawer-header-actions">
              <ActionButtons />
            </div>
          </Portal>
        )}
        <div className="full-height-without-details">
          {subscriptionInfoComponent}
        </div>
      </>
    );
  }

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton
          customLink={`${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}`}
        />
        <div className="portal-header">Edit End User</div>
      </Portal>
      <Portal portalId="header-right-content">
        <ActionButtons />
      </Portal>
      <Portal portalId="header-right-content-phones">
        <ActionButtons />
      </Portal>
      <EndUsersTabs endUserId={currentId} endUserNumber={currentUserNumber}>
        <div className="full-height-without-details">
          {subscriptionInfoComponent}
        </div>
      </EndUsersTabs>
    </>
  );
};

export default SubscriptionDetails;
